var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 265.88 365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(0.06 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265.82,
    height: 364.94,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.06,294.61l2.21-3.09L106.68,93.19l.22-2.1L60.82,4.54a8.55,8.55,0,0,0-16,2.7L-.06,294.61",
    transform: "translate(0.06 0)",
    fill: "#fec24b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.49,156.55l34.3-35.13L140.48,55.9a8.84,8.84,0,0,0-15.58,0l-18.33,35v3l33.92,62.7",
    transform: "translate(0.06 0)",
    fill: "#f3bd63"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "0 294.62 1 293.61 4.64 292.13 138.39 158.88 140.09 154.26 106.72 90.68 0 294.62",
    fill: "#f58220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.77,361.82l121-67.51L231.25,81.42a8.27,8.27,0,0,0-14-4.52L-.06,294.62l120.35,67.19a25.12,25.12,0,0,0,24.48,0",
    transform: "translate(0.06 0)",
    fill: "#fde068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.74,293.74,230.43,82.47c-1.07-6.61-7.87-9.35-12.6-4.61L1.28,294.2l119,66.53a24.93,24.93,0,0,0,24.3,0l120.13-67",
    transform: "translate(0.06 0)",
    fill: "#fcca3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.77,359.83a25.12,25.12,0,0,1-24.48,0L.91,293.59l-1,1,120.35,67.19a25.12,25.12,0,0,0,24.48,0l121-67.51-.3-1.82L144.77,359.83",
    transform: "translate(0.06 0)",
    fill: "#eeab37"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.413a0fd4.svg";
export { ForwardRef as ReactComponent };